import { Switch } from 'antd'
import React from 'react'

function DisabledToggle() {
  return (
    <Switch className='auf-toggle' disabled={true} defaultChecked />
  )
}

export default DisabledToggle